import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function ConnectionStatus() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('fr') ? 'fr' : 'en';
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  const label = online ? (lang === 'fr' ? 'En ligne' : 'Online') : (lang === 'fr' ? 'Hors ligne' : 'Offline');

  return (
    <div style={styles.container} title={online ? (lang === 'fr' ? 'Connecté' : 'Connected') : (lang === 'fr' ? 'Hors ligne' : 'Working offline')}>
      <span style={{ ...styles.dot, background: online ? '#34C759' : '#FF9500' }} />
      <span style={styles.label}>{label}</span>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed', top: '52px', right: '8px', zIndex: 800,
    display: 'flex', alignItems: 'center', gap: '4px',
    background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(8px)',
    borderRadius: '12px', padding: '3px 10px',
    fontSize: '0.7rem', fontWeight: 600, color: '#6E6E73',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    pointerEvents: 'none',
  },
  dot: { width: '6px', height: '6px', borderRadius: '50%', flexShrink: 0 },
  label: { letterSpacing: '0.3px' },
};
